import { BACK_TO_TOPICS, FORUM_ARCHIVED_CAMPAIGN_ACTIVE } from 'mk/autogenerated/translations/ArchivedCampaigns.546c8614d4f2d58d3ac674e2cc7e501c'
import { Props } from 'mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaignsPage';
import { forumTopicsUrl, forumTopicUrl } from 'mk2/apps/forum/urls';
import Btn, { BtnType } from 'mk2/components/Btn';
import Failure from 'mk2/components/errors/Failure';
import ListItem, { ListItemPlaceholder } from 'mk2/components/ListItem';
import { ListItemIcon } from 'mk2/components/ListItemIcon';
import { monthAndYear } from 'mk2/helpers/timeformat';
import { url } from 'mk2/helpers/urls';
import { isFailure, LoadingState } from 'mk2/reducers/loadingState';
import React from 'react';
import styles from './ArchivedCampaigns.mscss';

class ArchivedCampaigns extends React.Component<Props> {

    public componentWillMount() {
        const { loadingState, renderedAt } = this.props;

        // Load only if not loaded on server and is not older than 30s
        if ((loadingState !== LoadingState.SUCCESS_ON_SERVER && loadingState !== LoadingState.FAILURE_ON_SERVER) || renderedAt < Date.now() - 30 * 1000) {
            this.load();
        }
    }

    public shouldComponentUpdate(n: Props) {
        const p = this.props;

        return p.items !== n.items
            || p.loadingState !== n.loadingState;
    }

    public componentDidUpdate(prevProps: Props) {
        // State change LOADING -> FAILURE and we have some topics
        if (prevProps.loadingState === LoadingState.LOADING
            && this.props.loadingState === LoadingState.FAILURE
            && this.props.items.length) {
            this.props.onFailureToast();
        }
    }

    public render() {
        const { staticContext, loadingState, errorMessage, items } = this.props;

        return (
            <div className={styles.ArchivedCampaigns}>
                {loadingState === LoadingState.INIT || (loadingState === LoadingState.LOADING && items.length === 0) ? (
                    <span>
                        <ListItemPlaceholder icon isLast={false} />
                        <ListItemPlaceholder icon isLast={false} />
                        <ListItemPlaceholder icon isLast={false} />
                        <ListItemPlaceholder icon isLast={false} />
                        <ListItemPlaceholder icon isLast />
                    </span>
                ) : null}

                {isFailure(loadingState) && items.length === 0 ? (
                    <Failure
                        staticContext={staticContext}
                        errorMessage={errorMessage}
                        onRetry={this.load}
                        backButton={
                            <Btn
                                type={BtnType.Blue}
                                label={BACK_TO_TOPICS}
                                icon="fa-arrow-left"
                                link={forumTopicsUrl}
                            />
                        }
                    />
                ) : null}

                {items.length ? (
                    items.map((item, index) => (
                        <ListItem
                            key={index}
                            icon={<ListItemIcon lazy photo={item.topic.coverPhoto} />}
                            isLast={items.length === index + 1}
                            to={url(forumTopicUrl, {topicSlug: item.topic.slug})}
                        >
                            {item.topic.name}
                            <span className={styles.ArchivedCampaigns__date}>
                                {'(' + (item.isActive ? FORUM_ARCHIVED_CAMPAIGN_ACTIVE : monthAndYear(item.date)) + ')'}
                            </span>
                        </ListItem>
                    ))
                ) : null}
            </div>
        );
    }

    private load = () => {
        // Do not trigger next load
        if (this.props.loadingState === LoadingState.LOADING) {
            return;
        }

        const { onLoad } = this.props;
        onLoad();
    };
}

export default ArchivedCampaigns;
